import _get from "lodash/get";
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { ThemeContext } from 'styled-components';
import { ModalContext, modalPropTypes } from '~modal';
import { Button } from '~button';
import { GaIcon } from '~icon';
import { SrLabel } from '~helpers';
import MenuModal from './MenuModal';
import headerPropTypes from '../../prop-types/headerPropTypes';
import headerTheme from '../../styles/headerTheme';

var HeaderMenu = function HeaderMenu(_ref) {
  var list = _ref.list,
      secondaryList = _ref.secondaryList,
      onClickLinkCallback = _ref.onClickLinkCallback,
      currentPath = _ref.currentPath;

  var _useContext = useContext(ModalContext),
      showModal = _useContext.showModal,
      component = _useContext.component;

  var theme = useContext(ThemeContext);

  var menuIcon = _get(theme, 'header.menuModal.menuIcon.icon', headerTheme.header.menuModal.menuIcon.icon);

  var menuIconSize = _get(theme, 'header.menuModal.menuIcon.size', headerTheme.header.menuModal.menuIcon.size);

  var menuIconColor = _get(theme, 'header.menuModal.menuIcon.color', headerTheme.header.menuModal.menuIcon.color);

  return /*#__PURE__*/React.createElement(Button, {
    btnType: "link",
    skin: "muted",
    size: "sm",
    onClick: function onClick() {
      return showModal(MenuModal, {
        list: list,
        secondaryList: secondaryList,
        onClickLinkCallback: onClickLinkCallback,
        currentPath: currentPath
      });
    },
    disabled: !!component
  }, /*#__PURE__*/React.createElement(SrLabel, {
    as: "span"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "header.mobile.menu.title"
  })), /*#__PURE__*/React.createElement(GaIcon, {
    icon: menuIcon,
    size: menuIconSize,
    color: menuIconColor
  }));
};

HeaderMenu.defaultProps = {
  list: null,
  secondaryList: null,
  onClickLinkCallback: function onClickLinkCallback() {},
  currentPath: undefined
};
export default HeaderMenu;